import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import makeStyles from '@mui/styles/makeStyles';
type showSepratorProps = {
  smartEntryId: string;
  hasNoCptComb: boolean;
};

const useStyles = makeStyles((theme) => ({
  arrow: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    alignSelf: 'center',
    margin: theme.spacing(0, 0.5)
  },
  dot: {
    width: theme.spacing(0.7),
    height: theme.spacing(0.7),
    alignSelf: 'center',
    margin: theme.spacing(0, 0.5)
  }
}));

export const ShowSeprator: React.FC<showSepratorProps> = ({
  hasNoCptComb,
  smartEntryId
}: showSepratorProps) => {
  const classes = useStyles();
  if (hasNoCptComb) {
    return (
      <FiberManualRecordIcon
        data-testid={`smart-entry-item_CP_hierarchy_dot_${smartEntryId}`}
        className={classes.dot}
      />
    );
  } else {
    return (
      <ArrowForwardIcon
        data-testid={`smart-entry-item_CP_hierarchy_arrow_${smartEntryId}`}
        className={classes.arrow}
      />
    );
  }
};
